import type { ArcadeGalleryGame } from '@/types';
import { GameCard } from './game-card';

interface GamesGridProps {
  games: ArcadeGalleryGame[];
  isAuthenticated: boolean;
  hasGoogleAccount: boolean;
  votingOpen: boolean;
}

export function GamesGrid({
  games,
  isAuthenticated,
  hasGoogleAccount,
  votingOpen,
}: GamesGridProps) {
  if (games.length === 0) {
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-center">
        <p className="font-bold font-sans text-2xl text-primary">
          No games available yet
        </p>
        <p className="font-sans text-foreground/60 text-lg">
          Check back soon for awesome arcade games!
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {games.map((game) => (
        <GameCard
          key={game.id}
          game={game}
          isAuthenticated={isAuthenticated}
          hasGoogleAccount={hasGoogleAccount}
          votingOpen={votingOpen}
        />
      ))}
    </div>
  );
}
